import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { RequestQuerySortTypesEnum } from '../consts/enums';
// import { TALENT_PARAMS } from '../consts/requestParamsKeys';
import { Sort } from '../interfaces/apiRequest.interface';

const PAGE_PARAM_KEY = 'page';

export type ActiveFilters = {
  [key: string]: string[],
};

type MultiFilter = {
  [key: string]: string,
}

type TablePageParams = {
  activeFilters: ActiveFilters,
  onChangeFilter: (filterName: string | MultiFilter, newValue?: string[]) => void,
  currentPage: number,
  onPageChange: (newPage: number) => void,
  activeSort: Sort,
  onSortChange: (newSort: Sort) => void,
};

export const useTablePageParams = (filters: string[], defaultSort?: Sort): TablePageParams => {
  const [searchParams, setSearchParams] = useSearchParams();

  // todo MATAN: move state to URL
  const [activeSort, setActiveSort] = useState<Sort>(defaultSort || {
    // key should come from TALENT_PARAMS/ACCOUNT_PARAMS
    updatedAt: RequestQuerySortTypesEnum.Descendant,
  });

  const activeFilters: ActiveFilters = {};
  const currentPage = parseInt(searchParams.get(PAGE_PARAM_KEY) || '1');

  filters.forEach((filterName: string) => {
    const paramValues = searchParams.getAll(filterName);

    if (paramValues) {
      activeFilters[filterName] = paramValues;
    }
  });

  const handleChangeFilter = (filterName: string | MultiFilter, newValue?: string[]) => {
    // remove empty strings from filters
    const newValueWithoutEmpty = newValue?.filter((value) => !!value.trim());

    if (typeof filterName === 'object') {
      setSearchParams({
        ...activeFilters,
        ...filterName,
        [PAGE_PARAM_KEY]: '1',
      });

      return;
    }

    setSearchParams({
      ...activeFilters,
      [filterName]: newValueWithoutEmpty || [],
      [PAGE_PARAM_KEY]: '1',
    });
  };

  const handlePageChange = (newPage: number) => {
    setSearchParams({
      ...activeFilters,
      [PAGE_PARAM_KEY]: newPage.toString(),
    });
  };

  const handleSortChange = (newSort: Sort) => {
    setActiveSort(newSort);

    // return to first page
    setSearchParams({
      ...activeFilters,
      [PAGE_PARAM_KEY]: '1',
    });
  };

  return {
    activeFilters,
    onChangeFilter: handleChangeFilter,
    currentPage,
    onPageChange: handlePageChange,
    activeSort,
    onSortChange: handleSortChange,
  };
};
